import { ChangeDetectionStrategy, Component, HostListener, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { BasicDialogData } from '@app/shared/types/models/shared/confirmation-dialog.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';

@Component({
  selector: 'proffeo-confirmation-dialog',
  imports: [UiDialogComponent, MatDialogModule, UiButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './confirmation-dialog.component.html'
})
export class ConfirmationDialogComponent implements OnInit {
  private readonly dialogData: BasicDialogData = inject(MAT_DIALOG_DATA);
  private readonly dialogRef: MatDialogRef<ConfirmationDialogComponent> = inject(
    MatDialogRef<ConfirmationDialogComponent>
  );

  protected title: string;
  protected desc: string;

  @HostListener('window:keydown.escape', ['$event'])
  protected onEsc($event: KeyboardEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.close();
  }

  @HostListener('window:keydown.enter', ['$event'])
  protected onEnter($event: KeyboardEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.close(true);
  }

  public ngOnInit(): void {
    this.title = this.dialogData.title;
    this.desc = this.dialogData.desc;
  }

  protected close(decision?: boolean): void {
    this.dialogRef.close(decision);
  }
}
